import { VISIBILITY } from './requestConstants';

export const prettyEnum = (s) => {
    const raw = String(s || '').trim();
    if (!raw) return '—';
    return raw
        .toLowerCase()
        .split('_')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};

export const visibilityLabel = (v) => {
    switch (v) {
        case VISIBILITY.PUBLIC_ALL:
            return 'Customer and shops';
        case VISIBILITY.CUSTOMER_ONLY:
            return 'Customer only';
        case VISIBILITY.SUPPLIER_ONLY:
            return 'Shops only';
        case VISIBILITY.INTERNAL:
            return 'Internal note';
        default:
            return prettyEnum(v);
    }
};

export const visibilityNote = (visibility) => {
    switch (visibility) {
        case VISIBILITY.CUSTOMER_ONLY:
            return 'Only visible to customer';
        case VISIBILITY.SUPPLIER_ONLY:
            return 'Only visible to shops';
        case VISIBILITY.INTERNAL:
            return 'Internal note';
        case VISIBILITY.PUBLIC_ALL:
        default:
            return '';
    }
};

export const senderLabel = (msg) => {
    if (msg.direction === 'IN') return msg.authorName || 'Customer';
    if (msg.isEvent) return 'System';
    return msg.authorName || 'Team';
};

export const normalizeRequest = (r) => ({
    id: r?.id ?? '',
    status: r?.status ?? 'OPEN',
    serviceCategory: r?.serviceCategory ?? '',
    requestType: r?.requestType ?? '',
    entityType: r?.entityType ?? '',
    entityId: r?.entityId ?? '',
    preferredLanguage: r?.preferredLanguage ?? '',
    contactFirstName: r?.contactFirstName ?? '',
    contactLastName: r?.contactLastName ?? '',
    contactEmail: r?.contactEmail ?? '',
    contactPhoneCountry: r?.contactPhoneCountry ?? '',
    contactPhoneNumber: r?.contactPhoneNumber ?? '',
    contactCountry: r?.contactCountry ?? '',
    place: r?.place ?? '',
    plannedFrom: r?.plannedFrom ?? '',
    plannedTo: r?.plannedTo ?? '',
    partySize: typeof r?.partySize === 'number' ? r.partySize : 0,
    createdAt: r?.createdAt ?? '',
    updatedAt: r?.updatedAt ?? '',
});

export const normalizeMessages = (data) => {
    const items = Array.isArray(data) ? data : (data?.items ?? data?.data ?? []);

    return (items || []).map((m, index) => {
        const visibility = m?.visibility ?? VISIBILITY.CUSTOMER_ONLY;
        const isInternal = visibility === VISIBILITY.INTERNAL;

        const eventByContent = /^(status changed:|shops added|suppliers added|participant removed)/i
            .test(String(m?.content || ''));

        const eventByMeta =
            !!m?.meta?.status ||
            Array.isArray(m?.meta?.shopIds) ||
            Array.isArray(m?.meta?.supplierIds) ||
            !!m?.meta?.participantId ||
            !!m?.meta?.partyId ||
            !!m?.meta?.partyType ||
            !!m?.meta?.eventType;

        const isEvent = isInternal && (eventByContent || eventByMeta);

        const direction =
            m?.authorPartyType === 'CUSTOMER'
                ? 'IN'
                : isEvent
                    ? 'EVENT'
                    : 'OUT';

        const authorName =
            m?.authorName ??
            (m?.authorPartyType === 'CUSTOMER'
                ? 'Customer'
                : m?.authorPartyType === 'SHOP'
                    ? 'Shop'
                    : m?.authorPartyType === 'SUPPLIER'
                        ? 'Supplier'
                        : m?.authorPartyType === 'AGENT'
                            ? 'Agent'
                            : m?.authorPartyType === 'RMB'
                                ? 'RMB'
                                : 'Team');

        return {
            id: m?.id ?? `${m?.createdAt ?? ''}-${index}`,
            createdAt: m?.createdAt ?? '',
            direction,
            authorName,
            content: m?.content ?? m?.message ?? '',
            visibility,
            isInternal,
            isEvent,
            meta: m?.meta ?? null,
            authorPartyType: m?.authorPartyType,
            authorPartyId: m?.authorPartyId,
        };
    });
};

export const normalizeShops = (data) => {
    const items = data?.shops ?? data?.items ?? data?.data ?? (Array.isArray(data) ? data : []);
    return (items || [])
        .map((p) => ({
            participantId: p?.participantId ?? p?.id ?? '',
            shopId: p?.shopId ?? p?.partyId ?? p?.id ?? '',
            name: p?.name ?? p?.shop?.name ?? 'Shop',
            email: p?.email ?? p?.shop?.email ?? '',
        }))
        .filter((x) => x.shopId);
};

export const pad2 = (n) => String(n).padStart(2, '0');

export const toDateInputValue = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const toTimeInputValue = (value) => {
    if (!value) return '';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '';
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

export const extractApiArray = (response) => {
    const payload = response?.data;
    return Array.isArray(payload) ? payload : (payload?.data || []);
};

export const normalizeOptionItems = (items = []) => {
    if (!Array.isArray(items)) {
        return [];
    }

    return items.map((item) => ({
        ...item,
        value: item?.value ?? item?.id ?? '',
        label: item?.label ?? item?.name ?? '',
    }));
};

export const getInitialMotoSearchForm = (request) => ({
    countryId: '',
    cityId: '',
    locationId: '',
    startDate: toDateInputValue(request?.plannedFrom),
    startTime: /* toTimeInputValue(request?.plannedFrom) || */ '10:00',
    flexibleStartTime: true,
    endDate: toDateInputValue(request?.plannedTo),
    endTime: /* toTimeInputValue(request?.plannedTo) || */ '10:00',
    flexibleEndTime: true,
});